import React, { useState, useEffect } from 'react';
import serviceImg from 'theme/assets/images/service.png';
import { MethodEnum } from 'axios/type';
import useAxios from 'axios/useAxios';
import { getUserInfoReducer } from 'reducer/common/userInfo';
import { useSelector } from 'react-redux';
import StatusEnum from 'axios/enum';
import { showResponseSnackBar } from 'consts';
import { CUSTOMER_SERVICE_URL } from 'config';

const CustomerService = (): JSX.Element => {
  const { userId } = useSelector(getUserInfoReducer); // 取得userId值
  const [resultURL, setResultURL] = useState<string>(); // 宣告resultURL，setResultURL時進行異動
  const axios = useAxios();
  /** 打 user/getChatBotAuthHash API */
  /** 
  const getCustomerServiceURL = async () => {
    const response = await axios.doAxios<
      unknown,
      { ChatBotURL: string } // 回傳值
    >(MethodEnum.post, 'user/getChatBotAuthHash', {
      userId, // 傳遞參數
    });
    if (response) {
      if (response.data.status === StatusEnum.完成) {
        setResultURL(response.data.data.ChatBotURL); // 異動resultURL值
      } else {
        showResponseSnackBar(response.data);
      }
    }
  };
  */
  /** 當「userId」有變化，呼叫getCustomerServiceURL 取得 */
  /**
  useEffect(() => {
    if (userId !== '') {
      getCustomerServiceURL();
    }
  }, [userId]);
 */
  /** 目前先以固定URL進行文字客服導頁，日後待客服測試OK再替換API方式取的URL */
  return (
    <a
      href={CUSTOMER_SERVICE_URL}
      // href={resultURL}
      className="right_service"
      target="_blank"
      rel="noreferrer"
    >
      <div className="online-service">
        <img src={serviceImg} alt="" />
      </div>
    </a>
  );
};
export default CustomerService;
